import { AUTOMATIC_ID } from '../../constants';

export const isNotAutomaticId = (value: unknown): boolean => value !== AUTOMATIC_ID;
